/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";
import { showModal } from "actions";

import "components/widgets/training/Training.css";

class AvailableTraining extends Component {
  rowClassName = "";

  showDetail = (t, parentId) => {
    // NOTE: aktif edilmesi istenmedi
    return;

    //ELearning ise açılmasın
    // if (t.trainingMethod.value === 1) return;

    // this.props.showModal({
    //   modalType: "trainingDetail",
    //   modalTitle: "",
    //   modalContent: (
    //     <TrainingDetailModal
    //       training={t}
    //       trainingType="registered"
    //       isParent={t.isParent}
    //       parentId={parentId}
    //     />
    //   ),
    //   modalFooter: null,
    //   modalCustomClassName: "modal-xl ttModal",
    // });
  };

  showRequestDetail = () => {
    this.props.showModal({
      modalType: "detail",
      modalTitle: "Talep İşlemleri",
      modalContent: (
        <>
          Eğitime kayıt olmak için <b>Dicle Erim(derim@ford.com.tr)</b> ile
          iletişime geçebilirsiniz.
        </>
      ),
      modalFooter: null,
      modalCustomClassName: "modal-md",
    });
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTime = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleTimeString(localStorage.getItem("i18nextLng"));
  };

  renderDateTime = (type, dateString) => {
    //1 = ELearning
    if (type !== 1)
      return (
        <>
          {this.renderDate(dateString)}
          <br />
          {this.renderTime(dateString)}
        </>
      );
    else return this.renderDate(dateString);
  };

  renderTrainingMethodIcon = (value, isParent) => {
    if (isParent) {
      let icon = "iconmford fo-icon-add";
      if (!this.state.showingChildren) icon = "iconmford fo-icon-remove";
      return (
        <td
          className="showGrup openCloseBtn"
          style={{
            textAlign: "left",
            color: "rgb(45, 150, 205)",
            paddingLeft: "25px",
            fontSize: "20px",
          }}
        >
          <span className={icon}></span>
        </td>
      );
    } else {
      switch (value) {
        case 1:
          return (
            <td>
              <span className="iconmford fo-icon-live-tv "></span>
            </td>
          );
        case 3:
          return (
            <td className="showGrup">
              <span className="iconmford fo-icon-tv">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
              </span>
            </td>
          );
        default:
          return (
            <td>
              <span className="iconmford fo-icon-class"></span>
            </td>
          );
      }
    }
  };

  renderTabletModeDetail = (t) => {
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr>
                <td>
                  <div className="tableTitle">
                    <Trans desc="Yer">10016</Trans>
                  </div>
                </td>
                <td>{t.trainingLocation ?? ""}</td>
              </tr>
              <tr>
                <td>
                  <div className="tableTitle">
                    <Trans desc="Başlangıç">10020</Trans>
                  </div>
                </td>
                <td>
                  {this.renderDateTime(t.trainingMethod.value, t.startDate)}
                </td>
              </tr>
              <tr>
                <td>
                  <div className="tableTitle">
                    <Trans desc="Bitiş">10021</Trans>
                  </div>
                </td>
                <td>
                  {this.renderDateTime(t.trainingMethod.value, t.endDate)}
                </td>
              </tr>
              <tr>
                <td>
                  <div className="tableTitle"></div>
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-kaydet"
                    onClick={() => this.showRequestDetail()}
                  >
                    Talep
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { t } = this.props;

    return (
      <>
        <DesktopBreakpoint>
          <tr className="grupEgitim" key={t.key}>
            {this.renderTrainingMethodIcon(t.trainingMethod.value, t.isParent)}
            <td className="showGrup">{t.training?.name}</td>
            <td className="showGrup">{t.trainingLocation ?? ""}</td>
            <td className="showGrup">
              {this.renderDateTime(t.trainingMethod.value, t.startDate)}
            </td>
            <td className="showGrup">
              {this.renderDateTime(t.trainingMethod.value, t.endDate)}
            </td>
            <td>
              <button
                className="btn btn-sm btn-kaydet"
                onClick={() => this.showRequestDetail()}
              >
                Talep
              </button>
            </td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr key={t.key} className={this.rowClassName}>
            {this.renderTrainingMethodIcon(t.trainingMethod.value, t.isParent)}
            <td className="showGrup">{t.training?.name}</td>
          </tr>

          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, {
  showModal,
})(AvailableTraining);
